/**
 * Добавляет кастомные заголовки в XMLHttpRequest
 * @param {XMLHttpRequest} xhr - объект XMLHttpRequest
 * @param {Object} settings - настройки AJAX запроса
 * @param {Array} headers - массив объектов с полями name, value и опционально condition
 */
function addCustomHeaders(xhr, settings, headers) {
    if (!Array.isArray(headers) || headers.length === 0) {
        return;
    }

    headers.forEach((header) => {
        if (header.condition && typeof header.condition === 'function') {
            if (!header.condition(settings)) {
                return;
            }
        }

        // Получаем значение заголовка (может быть функцией или значением)
        let headerValue;
        if (typeof header.value === 'function') {
            headerValue = header.value();
        } else {
            headerValue = header.value;
        }

        if (headerValue) {
            xhr.setRequestHeader(header.name, headerValue);
        }
    });
}

export default addCustomHeaders;
